import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import Select from "react-select";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageDealerSection() {
  const [dealerSections, setDealerSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemID, setItemID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({
    builderName: "",
    estdYear: "",
    totalProjects: "",
    shortDescription: "",
    properties: [],
  });
  const [properties, setProperties] = useState([]);
  const [selectedProperties, setSelectedProperties] = useState([]);

  // Function to show details in popup
  const showDetailsPopup = (dealer, title = "Dealer Section Details") => {
    const propertiesHtml =
      dealer.properties && dealer.properties.length > 0
        ? dealer.properties
            .map(
              (prop, index) =>
                `<div style="margin-bottom: 5px; padding: 5px 10px; background: #f8f9fa; border-radius: 3px;">
            ${index + 1}. ${
                  prop?.aptName || prop?.name || "Property " + (index + 1)
                }
          </div>`
            )
            .join("")
        : '<p class="text-muted">No properties available</p>';

    Swal.fire({
      title: title,
      html: `
        <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Builder Name:</strong></h6>
          <p style="white-space: pre-wrap; word-wrap: break-word; margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 5px;">
            ${dealer.builderName || "No builder name available"}
          </p>
          
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px;">
            <div>
              <h6 style="color: #333; margin-bottom: 10px;"><strong>Established Year:</strong></h6>
              <p style="padding: 10px; background: #f8f9fa; border-radius: 5px;">
                ${dealer.estdYear || "N/A"}
              </p>
            </div>
            <div>
              <h6 style="color: #333; margin-bottom: 10px;"><strong>Total Projects:</strong></h6>
              <p style="padding: 10px; background: #f8f9fa; border-radius: 5px;">
                ${dealer.totalProjects || "0"}
              </p>
            </div>
          </div>
          
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Short Description:</strong></h6>
          <p style="white-space: pre-wrap; word-wrap: break-word; margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 5px;">
            ${dealer.shortDescription || "No description available"}
          </p>
          
          <h6 style="color: #333; margin-bottom: 10px;"><strong>Properties (${
            dealer.properties?.length || 0
          }):</strong></h6>
          <div style="max-height: 200px; overflow-y: auto;">
            ${propertiesHtml}
          </div>
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: "700px",
      customClass: {
        popup: "dealer-section-popup",
      },
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Builder Name",
      cell: (row) => {
        const builderName = row.builderName || "";
        const shortName =
          builderName.length > 20
            ? `${builderName.substring(0, 20)}...`
            : builderName;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {shortName || <span className="text-muted">No builder name</span>}
            </span>
            {builderName.length > 20 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() => showDetailsPopup(row)}
                title="View full details"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Est. Year",
      selector: (row) => row.estdYear || "N/A",
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Projects",
      cell: (row) => {
        const totalProjects = row.totalProjects || "0";
        return <span className="badge bg-info">{totalProjects}</span>;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Properties",
      cell: (row) => {
        const properties = row.properties || [];
        const propertyCount = properties.length;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {propertyCount > 0 ? (
                <>
                  <span className="badge bg-primary me-2">{propertyCount}</span>
                  <span>{propertyCount} properties</span>
                </>
              ) : (
                <span className="text-muted">No properties</span>
              )}
            </span>
            {propertyCount > 0 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() => showDetailsPopup(row)}
                title="View all properties"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Description",
      cell: (row) => {
        const description = row.shortDescription || "";
        const shortDescription =
          description.length > 30
            ? `${description.substring(0, 30)}...`
            : description;

        return (
          <div className="d-flex align-items-center">
            <span className="me-2">
              {shortDescription || (
                <span className="text-muted">No description</span>
              )}
            </span>
            {description.length > 30 && (
              <button
                type="button"
                className="btn btn-sm p-0"
                onClick={() => showDetailsPopup(row)}
                title="View full description"
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#007bff",
                  fontSize: "16px",
                }}
              >
                <i className="fa-solid fa-eye"></i>
              </button>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) =>
        new Date(
          row.createdAt || row.createdOn || row.updatedAt
        ).toLocaleDateString(),
      sortable: true,
      width: "130px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            onClick={() => handleEdit(row)}
            className="btn btn-sm me-2"
            style={{
              background: "transparent",
              border: "none",
              color: "rgb(133, 218, 79)",
            }}
          >
            <i className="fa-solid fa-pen-to-square fs-5"></i>
          </button>
          <button
            title="Delete"
            onClick={() => handleDelete(row._id)}
            className="btn btn-sm"
            style={{
              background: "transparent",
              border: "none",
              color: "#dc3545",
            }}
          >
            <i className="fa-solid fa-trash-can fs-5"></i>
          </button>
        </div>
      ),
      width: "120px",
    },
  ];

  // Fetch all dealer sections
  const fetchDealerSections = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getDealerSection();
      console.log("Dealer sections data:", res);

      if (res?.status) {
        setDealerSections(res.data || []);
      } else {
        toast.error(res?.message || "Failed to load dealer sections!");
        setDealerSections([]);
      }
    } catch (error) {
      console.error("Error fetching dealer sections:", error);
      toast.error("Failed to load dealer sections!");
      setDealerSections([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDealerSections();
  }, []);

  // Handle edit button click
  const handleEdit = async (row) => {
    setIsEdit(true);
    setItemID(row?._id);
    console.log("ID", row?._id);

    // Set edit data from row
    setEditData({
      builderName: row.builderName || "",
      estdYear: row.estdYear || "",
      totalProjects: row.totalProjects || "",
      shortDescription: row.shortDescription || "",
      properties: row.properties || [],
    });

    // Convert properties to react-select format
    const propertyOptions = (row.properties || []).map((property) => ({
      value: property._id,
      label: property.aptName || property.name || "Unknown Property",
      originalData: property,
    }));

    setProperties(propertyOptions);
    setSelectedProperties(propertyOptions);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  // Handle property selection change
  const handlePropertyChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setSelectedProperties(selectedOptions || []);
    setEditData((prev) => ({ ...prev, properties: selectedValues }));
  };

  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #ced4da",
      borderRadius: "0.375rem",
      padding: "2px 8px",
      minHeight: "45px",
      boxShadow: state.isFocused
        ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
        : "none",
      borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
      "&:hover": {
        borderColor: "#86b7fe",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e9ecef",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "0.875rem",
      padding: "4px 8px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      ":hover": {
        backgroundColor: "#dc3545",
        color: "white",
      },
    }),
  };

  // Handle delete button click with SweetAlert confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Dealer Section?",
      text: "Are you sure you want to delete this dealer section?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteDealerSection(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Dealer section has been deleted.", "success");
          fetchDealerSections();
        } else {
          toast.error(res?.message || "Failed to delete dealer section");
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete dealer section.", "error");
      }
    }
  };

  // Handle form submission for update
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!editData.builderName.trim()) {
      toast.error("Please enter builder name.");
      return;
    }

    if (!editData.estdYear.trim()) {
      toast.error("Please enter establishment year.");
      return;
    }

    if (!editData.totalProjects) {
      toast.error("Please enter total projects.");
      return;
    }

    if (!editData.shortDescription.trim()) {
      toast.error("Please enter short description.");
      return;
    }

    if (editData.properties.length === 0) {
      toast.error("Please select at least one property.");
      return;
    }

    // Validate year
    const currentYear = new Date().getFullYear();
    const estdYear = parseInt(editData.estdYear);
    if (isNaN(estdYear) || estdYear < 1900 || estdYear > currentYear) {
      toast.error(`Please enter a valid year between 1900 and ${currentYear}`);
      return;
    }

    // Validate total projects
    const totalProjects = parseInt(editData.totalProjects);
    if (isNaN(totalProjects) || totalProjects <= 0) {
      toast.error("Total projects must be a positive number");
      return;
    }

    try {
      // Prepare update data
      const data = {
        builderName: editData.builderName.trim(),
        estdYear: editData.estdYear.trim(),
        totalProjects: editData.totalProjects,
        shortDescription: editData.shortDescription.trim(),
        properties: editData.properties,
      };

      console.log("Updating dealer section with data:", data);

      const res = await HomeService.updateDealerSection(itemID, data);

      if (res?.status) {
        toast.success("Dealer section updated successfully!");
        setIsEdit(false);
        setEditData({
          builderName: "",
          estdYear: "",
          totalProjects: "",
          shortDescription: "",
          properties: [],
        });
        setProperties([]);
        setSelectedProperties([]);
        fetchDealerSections();
      } else {
        toast.error(res?.message || "Failed to update dealer section.");
      }
    } catch (error) {
      toast.error("Failed to update dealer section.");
      console.error("Error updating dealer section:", error);
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    setIsEdit(false);
    setEditData({
      builderName: "",
      estdYear: "",
      totalProjects: "",
      shortDescription: "",
      properties: [],
    });
    setProperties([]);
    setSelectedProperties([]);
  };

  // Fetch properties for editing
  const fetchPropertiesForDealer = async (dealerName) => {
    try {
      const data = { dealerName };
      const res = await HomeService.getPropertiesByDealerName(data);

      if (res?.status && res.data) {
        const propertyOptions = res.data
          .filter(
            (property) => property.aptName && property.aptName.trim() !== ""
          )
          .map((property) => ({
            value: property._id,
            label: property.aptName,
            originalData: property,
          }));

        setProperties(propertyOptions);
        return propertyOptions;
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      toast.error("Error loading properties");
    }
    return [];
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Edit Dealer Section</h4>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Builder Name Input (Read-only in edit mode) */}
                      <div className="col-md-12 mt-3">
                        <label htmlFor="builderName">
                          Builder Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="builderName"
                          className="form-control"
                          name="builderName"
                          value={editData?.builderName || ""}
                          onChange={handleInputChange}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                        <div className="form-text">
                          Builder name cannot be changed in edit mode
                        </div>
                      </div>

                      {/* Establishment Year */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="estdYear">
                          Establishment Year
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="estdYear"
                          className="form-control"
                          name="estdYear"
                          value={editData?.estdYear || ""}
                          onChange={handleInputChange}
                          placeholder="e.g., 2010"
                          min="1900"
                          max={new Date().getFullYear()}
                          required
                        />
                        <div className="form-text">
                          Year when the builder was established (1900-
                          {new Date().getFullYear()})
                        </div>
                      </div>

                      {/* Total Projects */}
                      <div className="col-md-6 mt-3">
                        <label htmlFor="totalProjects">
                          Total Projects<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="totalProjects"
                          className="form-control"
                          name="totalProjects"
                          value={editData?.totalProjects || ""}
                          onChange={handleInputChange}
                          placeholder="e.g., 25"
                          min="1"
                          required
                        />
                        <div className="form-text">
                          Total number of projects completed
                        </div>
                      </div>

                      {/* Short Description */}
                      <div className="col-md-12 mt-3">
                        <label htmlFor="shortDescription">
                          Short Description
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="shortDescription"
                          className="form-control"
                          name="shortDescription"
                          value={editData?.shortDescription || ""}
                          onChange={handleInputChange}
                          placeholder="e.g., Leading real estate developer with 25+ successful projects..."
                          rows="3"
                          required
                          maxLength="500"
                        />
                        <div className="form-text">
                          Brief description of the builder (max 500 characters)
                        </div>
                      </div>

                      {/* Properties Selection (Multi-select) */}
                      <div className="col-md-12 mt-3">
                        <label
                          htmlFor="propertiesSelect"
                          className="form-label"
                        >
                          Select Properties (with Apartment Names)
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          id="propertiesSelect"
                          options={properties}
                          value={selectedProperties}
                          onChange={handlePropertyChange}
                          placeholder={`Select properties for "${editData.builderName}"`}
                          isMulti
                          isClearable
                          styles={customStyles}
                          closeMenuOnSelect={false}
                          noOptionsMessage={() => "No properties found"}
                        />
                        <div className="form-text">
                          Select properties for this dealer section
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                      <button
                        type="submit"
                        className="btn btn-primary me-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-floppy-disk me-2"></i>
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="btn btn-secondary"
                        style={{
                          padding: "10px 25px",
                          fontWeight: "500",
                        }}
                      >
                        <i className="fa-solid fa-times me-2"></i>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Dealer Sections
                </div>
                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading dealer sections...</p>
                  </div>
                ) : dealerSections.length > 0 ? (
                  <div className="card">
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={dealerSections}
                        pagination
                        responsive
                        highlightOnHover
                        striped
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        noDataComponent={
                          <div className="text-center py-4">
                            <i className="fa-solid fa-building fa-2x text-muted mb-3"></i>
                            <p>No dealer sections found</p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <i className="fa-solid fa-building fa-3x text-muted mb-3"></i>
                      <h5>No Dealer Sections Available</h5>
                      <p className="text-muted">
                        There are no dealer sections to display at the moment.
                      </p>
                      <a
                        href="/add-dealer-section"
                        className="btn btn-primary mt-2"
                        style={{
                          background: "rgb(133, 218, 79)",
                          border: "none",
                        }}
                      >
                        <i className="fa-solid fa-plus me-2"></i>
                        Add New Dealer Section
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Add CSS for the popup */}
      <style>
        {`
          .dealer-section-popup .swal2-popup {
            max-width: 700px;
          }
          .dealer-section-popup .swal2-html-container {
            overflow: hidden;
          }
        `}
      </style>
    </>
  );
}

export default ManageDealerSection;
